import { observer } from 'mobx-react-lite'
import React from 'react'

export default observer(function AnalyticsBox({ text, icon, value }) {

  return (
    <div className="flex items-center border border-gray-200 dark:border-rb-dark-mode-lighter rounded-md p-4">
      <div className="bg-gray-100 dark:bg-rb-dark-mode-lighter rounded-md p-4 mr-4">
        <div className="opacity-35 dark:text-white">
          {icon}
        </div>
      </div>
      <div>
        <p className="text-xl font-bold dark:text-white">{value}</p>
        <p className="dark:text-gray-400">{text}</p>
      </div>
    </div>
  )
})